"use strict";

import {
    declareAiCapability,
    provideAiCapability,
} from "@medflyt/webapp-react/src/modules/ai-omnibar/ai-capability-registry";

// The mentions inbox describing its own two filters. It opens on everything except Done, which is why
// a request that names no status leaves that alone.
declareAiCapability({
    id: "mentionsInbox.filter",
    title: "Filter the mentions inbox",
    effect: "prefill",
    description:
        "Sets the filters on Notes > Inbox and re-applies them: the status of the mention, and a free-text search over names. The tab opens on everything except Done. Only works while that tab is open.",
    location: "the filter bar of the Notes > Inbox tab",
    scope: "page",
    permissionKey: "view_notes_section",
    params: [
        {
            name: "status",
            type: "enum",
            required: false,
            multiple: true,
            options: () => getMentionsInboxStatusOptions(),
            description: "Limit to mentions in these states."
        },
        {
            name: "search",
            type: "text",
            required: false,
            searchesFreeText: true,
            description: "Free text the table searches over names."
        }
    ],
    examples: ["mentions that are still open", "mentions for jane"]
});

let mentionsInboxScope = () => null;

function getMentionsInboxStatusOptions() {
    const dropdown = (mentionsInboxScope()?.filterBy?.dropdowns ?? []).find((one) => one.title === "Status");

    return (dropdown?.options ?? []).map((option) => ({
        value: String(option.id),
        label: String(option.label ?? option.id)
    }));
}

/*! @ngInject */
export function agencyMemberMentionsInboxCtrl(
  $scope,
  $rootScope,
  $timeout,
  $stateParams,
  NgTableParams,
  toaster,
  DatabaseApi,
  agencyMemberMentionsService,
  noteService,
  entityNotesModalService,
  Storage,
  noteConsts,
  SweetAlert,
  selectionLogic,
  createDropdownFilter,
) {
  $scope.dropdownFilterEvents = {
    onSelectionChanged: () => applyFilters(),
  };

  $scope.agencyMembers = DatabaseApi.getAgencyMembersWithPhoto();

  $scope.statuses = [
    { value: "NONE", text: "---", statusClass: "" },
    { value: "VIEWED", text: "Viewed", statusClass: "lightblue" },
    { value: "IN_PROGRESS", text: "In progress", statusClass: "orange" },
    { value: "DONE", text: "Done", statusClass: "green" }
  ];

  $scope.statusesHash = {
    "NONE": { value: "NONE", text: "---", statusClass: "" },
    "VIEWED": { value: "VIEWED", text: "Viewed", statusClass: "lightblue" },
    "IN_PROGRESS": { value: "IN_PROGRESS", text: "In progress", statusClass: "orange" },
    "DONE": { value: "DONE", text: "Done", statusClass: "green" }
  };

  $scope.filterBy = {
    dropdowns: [
      {
        title: "Status",
        entityPath: ["status"],
        values: $scope.statuses.filter(status => status.value !== 'DONE').map(_status => ({
          id: _status.value
        })),
        options: $scope.statuses.map(status => ({
          id: status.value,
          label: status.text
        }))
      },
    ]
  };

  const dropdownFilterManager = createDropdownFilter({
    dropdowns: $scope.filterBy.dropdowns
  });

  function initialize() {
    initTableColumns();
    $scope.loadItems();
    
    if ($stateParams.mentionId && $stateParams.noteId) {
      openMentionById($stateParams.mentionId, $stateParams.noteId, null)
    }
  }

  function initTableColumns() {
    var columns = Storage.getObject("agencyMemberMentionsTableSettings");

    if (columns && Object.keys(columns).length) {
      Object.keys(columns).forEach(function (t) {
        if (columns[t]) $scope.tableColumnsLength++;
      });

      $scope.tableColumns = columns;
    } else {
      $scope.tableColumns = {
        "Date posted": true,
        "Posted by": true,
        Note: true,
        Category: true,
      };
    }

    $scope.$watch(
      "tableColumns",
      function () {
        if ($scope.tableColumns) {
          Storage.setObject(
            "agencyMemberMentionsTableSettings",
            $scope.tableColumns
          );
          $scope.tableColumnsLength = 0;
          Object.keys($scope.tableColumns).forEach(function (t) {
            if ($scope.tableColumns[t]) $scope.tableColumnsLength++;
          });
          //   filterTable();
        }
      },
      true
    );
  }

  $scope.globalFilter = { val: "" };
  $scope.applyGlobalSearch = function (term) {
    var filter = { $: term };
    if ($scope.tableParams) {
      angular.extend($scope.tableParams.filter(), filter);
      $timeout(() => $scope.selectionLogic.initItemsCollection($scope.tableParams.data));
    } else {
      console.log("no table");
    }
  };

  function mapNotesMentionsData() {
    $scope.mentions = $scope.mentions.map(note => {
      const status = $scope.statusesHash[note.status];
      const patients = note.patients;
      const caregivers = note.caregivers;

      const subjectText = note.subject ? note.subject : noteConsts.NoteTypesTranslations[note.noteType];

      return {
        ...note,
        subjectText,
        patients,
        caregivers,
        statusText: status.text,
        statusClass: status.statusClass,
      };
    });

    $scope.mentions.forEach((note) => {
      $scope.selectionLogic.initItem(note);
    });
  }

  function initTable(mentions) {
    $scope.tableData = mentions;
    var options = {
      count: 25,
      sorting: { createdAt: "desc" },
    };
    $scope.tableParams = new NgTableParams(options, {
      counts: [10, 25, 50, 100],
      dataset: $scope.tableData,
    });

    if ($scope.globalFilter.val) {
      $scope.applyGlobalSearch($scope.globalFilter.val);
    }
  }

  const getProfile = (note) => {
    let profileType = "Caregiver";
    let profileId = note.caregiverId;
    let profileName;
    if (note.caregiverId === null && note.patientId !== null) {
      profileType = "Patient";
      profileId = note.patientId;
      if (note.patients.length > 0) {
        profileName = note.patients[0].displayName;
      }
    } else if (note.caregivers.length > 0) {
      profileName = note.caregivers[0].displayName;
    }
    return {
      type: profileType,
      id: profileId,
      profileName: profileName
    };
  };

  const initSelection = function () {
    $scope.selectionLogic = selectionLogic.createNewLogic(function (item) {
      $scope.selectionLogic.addItemToCollection(item);
    }, "mentionId");
  };

  const openMentionById = (mentionId, noteId, seenAt) => agencyMemberMentionsService
    .markMentionsAsRead([mentionId])
    .then(async () => {
      const noteDetails = await noteService.getNoteDetails(noteId);
      const profile = getProfile(noteDetails);
      entityNotesModalService.handleNotesModalOpen({
        profileId: profile.id,
        notesType: profile.type,
        profileName: profile.profileName
      });
      $scope.loadItems();
      if (seenAt === null && $rootScope.mentionesCount > 0) {
        $rootScope.mentionesCount -= 1;
      }
    })
    .catch(() => {
      toaster.pop("error", "Failed to mark note mention as read");
    });

  $scope.openMention = function (mention) {
    if (mention.noteType === noteConsts.NoteTypes.BULK) {
      return SweetAlert.swal({
        title: "Bulk Note Type",
        text: "cant open view for bulk note type",
        type: "warning",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "OK",
        closeOnConfirm: true
      });
    }

    openMentionById(mention.mentionId, mention.content.noteId, mention.content.seenAt);
  };


  mentionsInboxScope = () => $scope;

  const releaseMentionsInboxFilter = provideAiCapability("mentionsInbox.filter", (args) => {
    const applied = [];
    const asList = (value) => (Array.isArray(value) ? value : [value]);

    if (args.status !== undefined) {
      const dropdown = ($scope.filterBy?.dropdowns ?? []).find((one) => one.title === "Status");

      if (dropdown === undefined) {
        throw new Error("This tab has no status filter.");
      }

      const wanted = asList(args.status).map((one) => String(one).toLowerCase());
      const chosen = dropdown.options.filter(
        (option) =>
          wanted.includes(String(option.id).toLowerCase()) ||
          wanted.includes(String(option.label ?? "").toLowerCase())
      );

      if (chosen.length === 0) {
        throw new Error("A mention is not " + asList(args.status).join(" or ") + ".");
      }

      dropdown.values = chosen;
      applied.push(chosen.map((option) => String(option.label ?? option.id)).join(" and "));
    }

    if (args.search !== undefined) {
      $scope.globalFilter.val = String(args.search);
      applied.push('"' + String(args.search) + '"');
    }

    $scope.loadItems();

    return applied.length === 0
      ? "Re-ran the mentions inbox search"
      : "Showing mentions: " + applied.join(", ");
  });

  $scope.$on("$destroy", releaseMentionsInboxFilter);

  $scope.loadItems = function () {
    $scope.isLoading = true;
    agencyMemberMentionsService
      .getMentions({ done: false })
      .then((res) => {
        $scope.isLoading = false;
        $scope.mentions = res.data.mentions;
        initSelection();
        mapNotesMentionsData();
        applyFilters();
      })
      .catch(() => {
        $scope.isLoading = false;
        toaster.pop("error", "Failed to load mentions");
      });
  };

  $scope.markAsDone = function (mention) {
    agencyMemberMentionsService
      .markMentionsAsDone([mention.mentionId])
      .then(() => {
        toaster.pop("success", "Note mention marked as done");
        $scope.loadItems();

        if (mention.content.seenAt === null && $rootScope.mentionesCount > 0) {
          $rootScope.mentionesCount -= 1;
        }
      })
      .catch(() => {
        toaster.pop("error", "Failed to mark note mention as done");
      });
  };

  $scope.markSelectedAsDone = function () {
    const selectedRows = $scope.selectionLogic.getSelectedItems();
    const mentionIds = selectedRows.map(mention => mention.mentionId);
    if (mentionIds.length === 0) {
      return toaster.pop(
        "warning",
        "Failed to mark as done",
        "No mention was selected"
      );
    }

    agencyMemberMentionsService
      .markMentionsAsDone(mentionIds)
      .then(() => {
        toaster.pop("success", "Note mention marked as done");
        $scope.loadItems();
        if ($rootScope.mentionesCount > 0) {
          $rootScope.mentionesCount -= getUnSeenCountFromIds(mentionIds);
        }
      })
      .catch(() => {
        toaster.pop("error", "Failed to mark note mention as done");
      });
  };

  $scope.markSelectedAsRead = function () {
    const selectedRows = $scope.selectionLogic.getSelectedItems();
    const mentionIds = selectedRows.map(mention => mention.mentionId);
    if (mentionIds.length === 0) {
      return toaster.pop(
        "warning",
        "Failed to mark as read",
        "No mention was selected"
      );
    }

    agencyMemberMentionsService
      .markMentionsAsRead(mentionIds)
      .then(() => {
        toaster.pop("success", "Note mention marked as read");
        $scope.loadItems();

        if ($rootScope.mentionesCount > 0) {
          $rootScope.mentionesCount -= getUnSeenCountFromIds(mentionIds);
        }
      })
      .catch((err) => {
        console.log(err);
        toaster.pop("error", "Failed to mark note mention as read");
      });
  };

  $scope.markSelectedAsUnread = function () {
    const selectedRows = $scope.selectionLogic.getSelectedItems();
    const mentionIds = selectedRows.map(mention => mention.mentionId);
    if (mentionIds.length === 0) {
      return toaster.pop(
        "warning",
        "Failed to mark as unread",
        "No mention was selected"
      );
    }

    agencyMemberMentionsService
      .markMentionsAsUnread(mentionIds)
      .then(() => {
        toaster.pop("success", "Note mention marked as unread");
        $scope.loadItems();

        $rootScope.mentionesCount += getSeenCountFromIds(mentionIds);
      })
      .catch(() => {
        toaster.pop("error", "Failed to mark note mention as unread");
      });
  };

  function getSeenCountFromIds(mentionIds) {
    return $scope.tableData.filter(
      (mention) =>
        mentionIds.includes(mention.mentionId) &&
        mention.content.seenAt !== null
    ).length;
  }

  function getUnSeenCountFromIds(mentionIds) {
    return $scope.tableData.filter(
      (mention) =>
        mentionIds.includes(mention.mentionId) &&
        mention.content.seenAt === null
    ).length;
  }
  
  const applyFilters = () => {
    initTable($scope.mentions.filter(dropdownFilterManager.filter));
  };

  initialize();
};
